import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import JournalModel from 'donor-elf-web/models/journal';
import JournalGoalModel from 'donor-elf-web/models/journal-goal';
import JournalStageModel from 'donor-elf-web/models/journal-stage';
const SORT_STAGES_BY = ['sortOrder:asc'];
const SORT_GOALS_BY = ['goalTypeId:asc'];

export default class JournalInfo {
  constructor(journalModel: JournalModel) {
    this.journal = journalModel;
    if (journalModel) {
      this.sortedStages = sortByProperties(
        journalModel.journalStages.slice(),
        SORT_STAGES_BY,
      );
      this.askStage = this.sortedStages.find((x) => x.askStage)!;
      this.goals = sortByProperties(
        journalModel.journalGoals.slice(),
        SORT_GOALS_BY,
      );
      this.goals.forEach((goal) => (this.goalsById[goal.id] = goal));
      this.hasMultipleGoals = this.goals.length > 1;
    }
  }

  journal: JournalModel;
  declare sortedStages: JournalStageModel[];
  declare askStage: JournalStageModel;
  declare goals: JournalGoalModel[];
  goalsById: { [id: string]: JournalGoalModel } = {};
  hasMultipleGoals: boolean = false; //boolean
}
